import {
  getQueryParameters,
  isATSOrganization,
  isHRNotDisabled,
} from "utils/utils"
import { isCandidXMode, isLateralMode } from "utils/productUtils"
import { ENGLISH_LANGUAGE_CODE } from "utils/constants"
import { isOZAPI } from "utils/clientUtils"

export const getRareFormConfigurationFromCandidate = candidate => {
  return JSON.parse(
    (candidate && candidate.rareApplicationFormConfiguration) || "{}"
  )
}

export const getFormConfigurationFromTemplate = template => {
  const { language } = getQueryParameters()
  const defaultConfiguration = template
    ? JSON.parse(template.formConfiguration || "{}")
    : {}
  if (language && language !== ENGLISH_LANGUAGE_CODE) {
    const configuration = template.jsonConfigurations.find(
      x => x.languageCode === language
    )?.configuration
    if (configuration) {
      const configurationJSON = JSON.parse(configuration)
      return {
        ...defaultConfiguration,
        ...configurationJSON,
      }
    }
  }
  return defaultConfiguration
}

export const getFormConfigurationFromCandidate = candidate =>
  getFormConfigurationFromRole(candidate?.role)

export const getFormConfigurationFromRole = role => {
  if (role?.template) {
    return getFormConfigurationFromTemplate(role.template)
  }
  return role ? JSON.parse(role.formConfiguration || "{}") : {}
}

export const getFormConfigurationFromOrganization = organization => {
  return organization
    ? JSON.parse(
        organization.defaultConfiguration ||
          organization.formConfiguration ||
          "{}"
      )
    : {}
}

export const getScreenSections = (organization, configuration) => {
  const getDefaultSections = () => {
    if (isOZAPI(organization)) {
      return [
        "role",
        "general",
        "personal",
        "contact",
        "events",
        "application",
        "atsapplication",
        "uni",
        "sixth",
        "language",
        "background",
        "extenuating",
        "experience",
        "custom",
        "assessments",
        "documents",
      ]
    }
    if (isLateralMode()) {
      return [
        "role",
        "personal",
        "contact",
        "qualifications",
        "lateralexperience",
        "atsapplication",
        "documents",
        "custom",
        "language",
      ]
    }
    return [
      "role",
      "general",
      "personal",
      "contact",
      "events",
      "application",
      "atsapplication",
      "law",
      "sqe",
      "graduate",
      "uni",
      "sixth",
      "secondary",
      "language",
      "background",
      "extenuating",
      "experience",
      "custom",
      "assessments",
      "documents",
    ]
  }
  return configuration.sections || getDefaultSections()
}

export const getScreenConfiguration = (organization, screeningView) => {
  const views = getFormConfigurationFromOrganization(organization).views
  const view =
    screeningView && views
      ? views.find(x => parseInt(x.id) === parseInt(screeningView.id)) || {}
      : {}
  return view ? view.configuration || {} : {}
}

export const getDefaultScreenConfiguration = organization => {
  const views =
    organization && getFormConfigurationFromOrganization(organization).views
  return (views && (views.find(x => x.default) || views[0])) || {}
}

export const showEvents = organization => {
  const oconfiguration = getFormConfigurationFromOrganization(organization)
  return isATSOrganization(organization)
    ? isHRNotDisabled(oconfiguration, "events")
    : isCandidXMode()
}

export const validateAndPrettifyJSON = config => {
  let prettyConfig = config
  let validJSON = !config
  try {
    if (config) {
      prettyConfig = JSON.stringify(JSON.parse(config), null, 2)
    }
    validJSON = true
  } catch (e) {
    validJSON = false
  }

  return [validJSON, prettyConfig]
}

/*
 * orgconfig.textArrays.timezones has a list of timezoneIANA;timezoneLabels.
 * This function returns the timezoneLabel for the timezoneIANA as defined in org config.
 */
export const getTimezoneLabelFromOrganizationConfig = (
  timezoneIANA,
  orgConfig
) => {
  let timezoneLabel = orgConfig.textArrays?.timezones
    ?.find(it => it.split(";")[0] === timezoneIANA)
    ?.split(";")[1]

  if (!timezoneLabel) {
    timezoneLabel = "UK Time"
  }

  return timezoneLabel
}
